import { Platform } from '@angular/cdk/platform';
import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { FadeWord } from '@box-core/animations';
import { Subscription } from 'rxjs';
import { LandingHeroWordsService } from './landing-hero-words.service';

@Component({
  selector: 'landing-hero-words',
  templateUrl: './landing-hero-words.component.html',
  styleUrls: ['./landing-hero-words.component.scss'],
  providers: [LandingHeroWordsService],
  animations: [FadeWord]
})
export class LandingHeroWordsComponent implements OnInit, OnDestroy {
  @Input() public words: string[];
  private wordSubscription: Subscription;

  public currentWord: string;

  constructor(private platform: Platform, private landingHeroWordsService: LandingHeroWordsService) {}

  @HostBinding('class') public hostClass = 'landing-hero-words';

  ngOnInit(): void {
    this.initiateWordsSequence();
  }

  ngOnDestroy(): void {
    if (this.wordSubscription) this.wordSubscription.unsubscribe();
  }

  private initiateWordsSequence(): void {
    if (!this.words?.length) return undefined;
    if (this.words.length === 1) return void (this.currentWord = this.words[1]);
    if (!this.platform.isBrowser) return undefined;
    this.landingHeroWordsService.initiateRollSequence(this.words);
    this.setWordSubscription();
  }

  private setWordSubscription(): void {
    this.wordSubscription = this.landingHeroWordsService.word$.subscribe((word) => (this.currentWord = word));
  }
}
